import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.testimonial-slider-with-heading' ).length ) {
        document.querySelectorAll( '.js-match-prev-bg' ).forEach( ( el ) => {
          const section = el.closest( 'section' );
          if ( !section ) return;

          const prev = section.previousElementSibling;
          if ( !prev ) return;

          const bg = window.getComputedStyle( prev ).backgroundColor;
          el.style.backgroundColor = bg;
        } );
        $( '.testimonial-slider-with-heading' ).each( function( index, element ) {
          const splide = new Splide( element, {
            type: 'loop',
            gap: '2rem',
            perPage: 2,
            perMove: 1,
            pagination: false,
            speed: 800,
            breakpoints: {
              768: {
                perPage: 1,
              },
            },
          } ).on( 'setPosition', function( event, slick ) {
            // set all slides to height of tallest slide
            slick.$slides.css( 'height', slick.$slideTrack.height() + 'px' );
          } ).mount( {} );

          splide.on( 'overflow', function( isOverflow ) {
            splide.options = {
              arrows: isOverflow,
              drag: isOverflow,
            };
          } );
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'testimonial-slider-with-heading', COMPONENT );
} )( app );
